(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-media-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landing-carousel')) {
    class LandingCarousel extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.#onClick);
      }

      #onClick = (event) => {
        const direction = event.target.closest('[data-next]') ? 1 : event.target.closest('[data-prev]') ? -1 : 0;
        if (!direction) return;
        const track = this.querySelector('[data-track]');
        const slide = track?.firstElementChild;
        if (!track || !slide) return;
        const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0');
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        const atStart = track.scrollLeft <= 2;
        if (direction === 1 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (direction === -1 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: step * direction, behavior: 'smooth' });
      };
    }

    customElements.define('landing-carousel', LandingCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
